import React from 'react';
import './button.css';
import Image from "../theme/Image";

export default function ({image, imageStyle, containerStyle, boxStyle, textStyle, width, height, padding="0.36rem", onClick, title, children}) {
    let imageEl;

    if(image && image !== false){
        let imageStyles = {
            display: "block",
            paddingTop: "2.14rem",
            marginLeft: "auto",
            marginRight: "auto",
            maxHeight: "calc(100% - 6.43rem)",
            maxWidth: '90%',
            ...imageStyle
        };
        imageEl = (
            <Image image={image} alt={'image'} style={imageStyles}/>
        );
    }

    let boxStyles = {
        width: "100%",
        height: "100%",
        position: "relative",
        overflowWrap: "anywhere",
        maxHeight: "100%",
        ...(boxStyle ?? {})
    };

    let textStyles = {
        position: "absolute",
        bottom: "1.43rem",
        width: "100%",
        textAlign: "center",
        fontSize: '1.1rem',
        ...(textStyle ?? {})
    };

    return (
        <div style={{
            width: width || "100%",
            height: height || "100%",
            boxSizing: "border-box",
            padding,
            float: "left",
            ...containerStyle
        }} onClick={onClick}>
            <div className={'shadowBox'} style={boxStyles}>
                {imageEl}
                {children}
                <div className={'boldUppercaseText'} style={textStyles}>{title}</div>
            </div>
        </div>
    );
}